<template>
    <div>
        <Header></Header>
        <b-container>
          <loader v-if="loader"></loader>
          <b-container v-else class="main-container p-0">
            <b-row class="user-bill" no-gutters>
              <b-col class="user-bill-info" cols="12">
                <div class="bill-info-head">
                  {{'headerQA' | localize}}
                </div>

                <div class="accordion" role="tablist">
                  <b-card no-body class="mb-1" v-for="(item, index) in faq" :key="index">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle="'accordion-' + index" variant="info" class="btn-light">{{ item[$store.state.lang].q }}</b-button>
                    </b-card-header>
                    <b-collapse :id="'accordion-' + index" :visible="index === 0" accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text><span v-html="item[$store.state.lang].a"></span></b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>

              </b-col>
            </b-row>
          </b-container>

        </b-container>  
    </div> 
</template>
<script>
import Header from '../components/Header'
import loader from '../components/Loader'
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from "axios";
export default {
    data: ()=> ({
      loader: true,
      faq:{},
    }),
    computed: mapGetters(['locale', 'lang']),
    mounted(){
      this.getFAQ()
    },
    methods: {
      async getFAQ(){
        await axios.get(
            `${config.API_URL}/api/rest/receipt/get_q_answer_open`,
            {
              headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
            },
        ).then((response) => {
          this.faq = response.data.items
          this.loader = false;
        })
      }
    },
 components: { Header, loader},
    
}
</script>

<style scoped>
.card{
  min-height: 10px;
  border: none;
}
.collapse{
  padding: 15px 10px 25px 15px;
}
.card-header{
  border: none;
}
.card-header button {
  text-align: left;
  font-weight: bold;
}

.accordion{
  margin: 10px;
}
</style>